import $ from 'jquery'
import Notification from '@polleverywhere/toolkit/components/notification'

function displayToast (message = '', options = {}) {
  switch (options.type) {
    case 'error':
    case 'invalid_code':
      this.error(message, options)
      break
    case 'success':
      this.success(message, options)
      break
    case 'warning':
      this.warning(message, options)
      break
    case 'announcement':
      this.notice(message, options)
      this.on('click:dismiss', readAnnouncement)
      break
    default:
      this.notice(message, options)
  }

  return this
}

const readAnnouncement = function () {
  return $.ajax({
    url: '/profile/read_announcement.json',
    type: 'PUT'
  })
}

$(function () {
  const toast = new Notification({ mode: 'toast' })
  $('#notice').append(toast.render().$el)
  $.notify = function (message = '', options = {}) {
    if (options.primaryLabel) {
      toast.options.primaryLabel = options.primaryLabel
      toast.render()
      if (options.primaryCallback) {
        toast.on('click:primary', options.primaryCallback)
      }
    }
    displayToast.call(toast, message, options)
  }

  if ($('meta[name=\'toast\']').length) {
    const parts = $('meta[name=\'toast\']').attr('content').split('/')
    if (parts[0] === 'sticky') {
      toast.options.autoHideAfter = -1
      parts.splice(0, 1)
    }
    const type = parts.shift()
    const message = parts.join('/')
    displayToast.call(toast, message, { type })
  }
})
